import { render } from "./HumanMethod.vue?vue&type=template&id=61f207f8"
import script from "./HumanMethod.vue?vue&type=script&lang=js"
export * from "./HumanMethod.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__